import * as Types from '../actions/types';
import * as Constant from 'common/Constant';

let initialState = {
  data: [],
  currentMenu: {name: Constant.ALL, key: Constant.ALL},
  currentTags: [],
  workbooks: [],
  projects: [],
  workbooksLoading: true,
  projectsLoading: true,
  adHocPublic: [],
  adHocPersonal: [],
  adHocFolder: [],
  adHocLoading: false,
};

export default function customReportReducer(state = initialState, action) {
  switch (action.type) {
    case Types.SET_CURRENT_SELECTED_MENU:
      return {
        ...state,
        currentMenu: action.data
      };
    case Types.SET_CURRENT_TAGS:
      return {
        ...state,
        currentTags: action.data
      };
    case Types.SET_CUSTOM_WORKBOOKS_REQUEST:
      return {
        ...state,
        workbooksLoading: true
      };
    case Types.SET_CUSTOM_PROJECTS_REQUEST:
      return {
        ...state,
        projectsLoading: true
      };
    case Types.SET_CUSTOM_WORKBOOKS:
      return {
        ...state,
        workbooks: action.data,
        workbooksLoading: false
      };
    case Types.SET_CUSTOM_PROJECTS:
      return {
        ...state,
        projects: action.data,
        projectsLoading: false
      };
    case Types.SET_DATA:
      if (Array.isArray(action.data)) {
        return {
          ...state,
          data: action.data
        }
      } else {
        const newData = [];
        newData.push(action.data);
        return {
          ...state,
          data: newData
        }
      }
    case Types.FETCH_ADHOC_REPORTS_REQUEST:
      return {
        ...state,
        adHocLoading: true
      };
    case Types.FETCH_ADHOC_REPORTS_SUCCESS:
      return {
        ...state,
        adHocPublic: Array.isArray(action.payload?.adHocPublic) ? action.payload.adHocPublic : [],
        adHocPersonal: Array.isArray(action.payload?.adHocPersonal) ? action.payload.adHocPersonal : [],
        adHocFolder: Array.isArray(action.payload?.adHocFolder) ? action.payload.adHocFolder : [],
        adHocLoading: false
      };
    case Types.FETCH_ADHOC_REPORTS_FAILURE:
      return {
        ...state,
        adHocPublic: [],
        adHocPersonal: [], 
        adHocFolder: [],
        adHocLoading: false
      };
    default:
      return {
        ...state
      };
  }
}
